import { useEffect } from 'react';

const useEventListener = (
    type: string,
    listener: EventListenerOrEventListenerObject,
    target?: EventTarget | null,
    options?: boolean | AddEventListenerOptions
) => {
    useEffect(() => {
        if (!target) {
            return;
        }

        target.addEventListener(type, listener, options);

        return () => {
            target.removeEventListener(type, listener, options);
        };
    }, [target, type, listener, options]);
};

export default useEventListener;
